
import Teaser from '@/components/Teaser.vue'
import Slider from '@/components/Slider.vue'
import { defineComponent, ref } from 'vue'
import StoryblokClient from 'storyblok-js-client'

const storyapi = new StoryblokClient({
  accessToken: process.env.VUE_APP_API_TOKEN
})

export default defineComponent({
  components: {
    Slider,
    Teaser
  },
  setup () {
    const story = ref({
      content: {
        body: [
          {
            component: ''
          }
        ]
      }
    })

    return {
      story
    }
  },
  methods: {
    getStory (slug: string) {
      storyapi.get('cdn/stories/' + slug)
        .then((response) => {
          this.story = response.data.story
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  created () {
    window.storyblok.init({
      accessToken: process.env.VUE_APP_API_TOKEN
    })
    window.storyblok.on('change', () => {
      this.getStory('home')
    })
    window.storyblok.pingEditor(() => {
      if (window.storyblok.isInEditor()) {
        this.getStory('home')
      } else {
        this.getStory('home')
      }
    })
  }
})
